import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { webappRoute } from "./layout"

export const auraScanRoute = createRoute({
  getParentRoute: () => webappRoute,
  path: "/aura-scan",
  component: lazyRouteComponent(() => import("./lazy-pages"), "AuraScanPage"),
})
